import React from "react";
import Home from "./screens/Home";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const App = () => {
  return (
    <div className=" bg-dark min-h-screen text-white">
      <Home />
    </div>
  );
};

export default App;
